import React from 'react';

import {Permissions} from 'auth/PermissionConstants';
import DataConnector from 'connect/DataConnector';
import {AaSequenceHistoryPanelState} from 'FileStates';
import AaSequence from 'molbio/aa-sequences/AaSequence';
import AaSequenceActions from 'molbio/aa-sequences/AaSequenceActions';
import AaSequenceStore from 'molbio/aa-sequences/AaSequenceStore';
import {ProteinVersion} from 'molbio/aa-sequences/util/AaSequenceConstants';
import ReactPanelBaseView, {getTabAndPanelIds, Subpanel} from 'toolbar/ReactPanelBaseView';
import HistoryPanelComponent from 'toolbar/shared/HistoryPanelComponent';

class AaSequenceHistoryPanelConnector extends DataConnector<Props, EnhancedProps> {
  override shouldSubscribeToRedux = false;
  override stores = [AaSequenceStore];

  enhanceProps(): EnhancedProps {
    const aaSequence = this.aaSequenceStore().getAaSequenceById(this.props.id)!;
    const versions = this.aaSequenceStore().getVersionsById(this.props.id);
    const openVersionId = aaSequence.version.id;
    const {isLatest} = aaSequence;
    return {
      versions,
      openVersionId,
      isLatest,
      versionsWereTruncated: this.aaSequenceStore().getVersionsWereTruncated(this.props.id),
    };
  }
}

interface Props {
  id: string;
  permissions?: Permissions;
}

interface EnhancedProps {
  versions: Array<ProteinVersion>;
  openVersionId: number;
  isLatest: boolean;
  versionsWereTruncated: boolean;
}

class AaSequenceHistoryPanel extends React.Component<Props & EnhancedProps> {
  openVersion = (versionId: string | number): void => {
    AaSequenceActions.open(this.props.id, {versionId: versionId as number});
  };

  resetToVersion = (): void => {
    AaSequenceActions.revert(this.props.id, this.props.openVersionId);
  };

  override render(): JSX.Element {
    return (
      <HistoryPanelComponent
        openVersion={this.openVersion}
        resetToVersion={this.resetToVersion}
        versions={this.props.versions}
        openVersionId={this.props.openVersionId}
        isLatest={this.props.isLatest}
        unsaved={false}
        showNames={true}
        showSeconds={true}
        hasParent={false}
        parent={null}
        permissions={this.props.permissions}
        dirty={false}
        versionsWereTruncated={this.props.versionsWereTruncated}
      />
    );
  }
}

const ConnectedAaSequenceHistoryPanel = AaSequenceHistoryPanelConnector.connect(AaSequenceHistoryPanel);

class AaSequenceHistoryPanelView extends ReactPanelBaseView<AaSequenceHistoryPanelState, AaSequence> {
  getSubpanels(): Array<Subpanel> {
    return [
      {
        ...getTabAndPanelIds('history'),
        title: 'History',
        component: (
          <ConnectedAaSequenceHistoryPanel id={this.model.id} permissions={this.model.permissions()} />
        ),
      },
    ];
  }
}

export default AaSequenceHistoryPanelView;
